module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-office-forms ccm-page"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), _c('Header'), _c('Instagram'), (!_vm.loading) ? _c('main', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-sm-8",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  }), _c('div', {
    staticClass: "col-sm-2"
  })])])])]), _c('div', {
    staticClass: "saprater-mian"
  })]) : _vm._e(), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('p', [_c('strong', [_vm._v("Get more practice news and updates and see many more photos on our Facebook page!")])]), _c('p', [_c('strong', [_c('br')])]), _c('h5', [_vm._v("FIND US ON FACEBOOK")]), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/UpdikeOrtho",
      "target": "_blank"
    }
  }, [_c('picture', [_c('img', {
    staticClass: "ccm-image-block img-responsive bID-511",
    attrs: {
      "src": "https://updikeortho.com/wp-content/uploads/2019/03/facebook-icon-40x40.png",
      "alt": "Find us on Facebook"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1c865ae","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/news/news.pug
// module id = 576
// module chunks = 1